// import React, { useEffect, useState, useMemo, memo, useCallback } from "react";
// import "react-phone-input-2/lib/style.css";
// import { NavLink } from "react-router-dom";
// import apiKey from "../../../config/apiKey";
// import axios from "axios";
// import { toast } from "react-toastify";
// import Select from "react-select";

// const GradientButton = memo(({ children, className = "", ...props }) => (
//   <button
//     {...props}
//     className={`bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] hover:from-[#2A3A54] hover:to-[#EE5F2B] text-white font-semibold text-sm px-5 py-2 rounded-lg shadow-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
//   >
//     {children}
//   </button>
// ));

// const Input = memo(({ className = "", ...p }) => (
//   <input
//     {...p}
//     className={`outline-none px-3 py-2 w-full bg-[#F9FBFF] border border-[#F0F2F7] rounded-lg focus:ring-2 focus:ring-[#EE5F2B]/30 ${className}`}
//   />
// ));

// const Textarea = memo(({ className = "", ...p }) => (
//   <textarea
//     {...p}
//     className={`outline-none px-3 py-2 w-full bg-[#F9FBFF] border border-[#F0F2F7] rounded-lg focus:ring-2 focus:ring-[#EE5F2B]/30 ${className}`}
//   />
// ));

// const Card = memo(({ title, children, className = "" }) => (
//   <div className={`rounded-2xl border border-[#E9EDF3] bg-white shadow-sm p-5 ${className}`}>
//     {title && <h3 className="text-lg font-semibold text-gray-800 mb-3">{title}</h3>}
//     {children}
//   </div>
// ));

// const OtherDetails = () => {
//   const teacher = JSON.parse(localStorage.getItem("edo-teacher"));
//   const authHeaders = useMemo(
//     () => ({ headers: { Authorization: `Bearer ${teacher?.token}` } }),
//     [teacher?.token]
//   );

//   const [isLoading, setIsLoading] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [errors, setErrors] = useState({});
//   const [showModal, setShowModal] = useState(false);
//   const [skills, setSkills] = useState([]);

//   const [formData, setFormData] = useState({
//     skill_id: [],
//     currently_working: "no",
//     bio: "",
//     degree: "",
//     school: "",
//     graduation_year: "",
//     title: "",
//     company: "",
//     start_month: "",
//     start_year: "",
//     end_month: "",
//     end_year: "",
//     description: "",
//   });

//   const monthNames = useMemo(
//     () => [
//       "January","February","March","April","May","June",
//       "July","August","September","October","November","December",
//     ],
//     []
//   );

//   // ---------- handlers ----------
//   const handleChange = useCallback((e) => {
//     const { name, value } = e.target;

//     if (name === "currently_working") {
//       const working = value;
//       setFormData((prev) => ({
//         ...prev,
//         [name]: working,
//         ...(working === "yes" ? { end_month: "", end_year: "" } : {}),
//       }));
//       setErrors((prev) => ({ ...prev, [name]: "" }));
//       return;
//     }

//     setFormData((prev) => ({ ...prev, [name]: value }));
//     setErrors((prev) => ({ ...prev, [name]: "" }));
//   }, []);

//   const handleChangeSkills = useCallback((selectedOptions) => {
//     const selectedValues = (selectedOptions || []).map((o) => o.value);
//     setFormData((prev) => ({ ...prev, skill_id: selectedValues }));
//     setErrors((prev) => ({ ...prev, skill_id: "" }));
//   }, []);

//   const handleSubmit = useCallback(
//     async (e) => {
//       e.preventDefault();
//       setIsLoading(true);

//       try {
//         const { data } = await axios.post(
//           `${apiKey}/api/edolutions/teacher/add-users-details`,
//           formData,
//           authHeaders
//         );

//         toast.success(data?.message || "Saved", {
//           position: "bottom-right",
//           autoClose: 4000,
//           theme: "colored",
//           style: { background: "#2A3A54", color: "#fff" }, // fixed typo: style
//         });
//       } catch (err) {
//         if (err.response?.data?.data) {
//           setErrors(err.response.data.data);
//         } else {
//           setErrors({ general: "An unexpected error occurred" });
//         }
//       } finally {
//         setIsLoading(false);
//       }
//     },
//     [formData, authHeaders]
//   );

//   // ---------- effects ----------
//   useEffect(() => {
//     let cancel = false;
//     (async () => {
//       setLoading(true);
//       try {
//         const [skillsRes, detailsRes] = await Promise.all([
//           axios.get(`${apiKey}/api/edolutions/teacher/skills`, authHeaders),
//           axios.get(`${apiKey}/api/edolutions/teacher/users-details`, authHeaders),
//         ]);

//         if (cancel) return;

//         setSkills(skillsRes.data || []);

//         if (detailsRes.data?.[0]) {
//           const d = detailsRes.data[0];
//           setFormData((prev) => ({
//             ...prev,
//             ...d,
//             skill_id: Array.isArray(d.skill_id) ? d.skill_id : [],
//             currently_working:
//               d.currently_working === "yes" || d.currently_working === "no"
//                 ? d.currently_working
//                 : "no",
//             bio: d.bio || "",
//             degree: d.degree || "",
//             school: d.school || "",
//             graduation_year: d.graduation_year || "",
//             title: d.title || "",
//             company: d.company || "",
//             start_month: d.start_month || "",
//             start_year: d.start_year || "",
//             end_month: d.end_month || "",
//             end_year: d.end_year || "",
//             description: d.description || "",
//           }));
//         }
//       } catch (e) {
//         console.error(e);
//       } finally {
//         if (!cancel) setLoading(false);
//       }
//     })();

//     return () => {
//       cancel = true;
//     };
//   }, [authHeaders]);

//   // ---------- derived ----------
//   const skillOptions = useMemo(
//     () => (skills || []).map((s) => ({ value: s.id, label: s.skill_name })),
//     [skills]
//   );

//   const selectedSkillOptions = useMemo(
//     () => skillOptions.filter((o) => formData.skill_id.includes(o.value)),
//     [skillOptions, formData.skill_id]
//   );

//   const currentlyWorking = formData.currently_working === "yes";
//   const disableEndDate = currentlyWorking;

//   // ---------- render ----------
//   return (
//     <>
//       <div className="flex items-center xl:p-5 sm:p-0 justify-center">
//         <div className="w-full border rounded-3xl shadow-xl p-5 px-6 md:px-10 bg-white">
//           {/* Header */}
//           <div className="flex items-center justify-between">
//             <h1 className="text-2xl font-bold text-gray-800">Settings</h1>
//             <GradientButton onClick={handleSubmit} disabled={isLoading}>
//               {isLoading ? "Saving..." : "Save"}
//             </GradientButton>
//           </div>

//           {/* Tabs */}
//           <div className="flex flex-wrap gap-6 border-b pb-3 text-sm font-semibold text-gray-700 mt-5">
//             <NavLink
//               to=".././profile-setting-tech"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
//                   : "hover:text-[#2A3A54]"
//               }
//             >
//               Profile Settings
//             </NavLink>

//             <NavLink
//               to=".././specialization-tech"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
//                   : "hover:text-[#2A3A54]"
//               }
//             >
//               Specializations & WP
//             </NavLink>

//             <span className="text-[#EE5F2B] border-b-2 border-[#EE5F2B]">
//               Other Details
//             </span>

//             <NavLink
//               to=".././security"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
//                   : "hover:text-[#2A3A54]"
//               }
//             >
//               Privacy & Security
//             </NavLink>
//           </div>

//           {/* Loading / Empty / Content */}
//           {loading ? (
//             <div className="w-full py-10 grid place-items-center">
//               <div className="w-12 h-12 border-4 rounded-full border-[#F0F0F0] border-t-[#EE5F2B] animate-spin"></div>
//               <p className="mt-4 font-semibold text-[#EE5F2B]">Cabil...</p>
//             </div>
//           ) : skills.length === 0 ? (
//             <div className="w-full py-10 text-center text-gray-500">
//               No Skills Available
//             </div>
//           ) : (
//             <>
//               {/* Personal + Skills */}
//               <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
//                 <Card title="Personal">
//                   <label className="text-sm font-semibold">Your Bio</label>
//                   <Textarea
//                     rows={5}
//                     placeholder="Add a short bio to showcase your best self."
//                     name="bio"
//                     value={formData.bio || ""}
//                     onChange={handleChange}
//                     className="mt-2"
//                   />
//                   {errors.bio && (
//                     <p className="text-red-500 text-sm mt-1">*Insert Bio!</p>
//                   )}
//                 </Card>

//                 <Card title="Select your Skills">
//                   <Select
//                     className="mt-1"
//                     options={skillOptions}
//                     isMulti
//                     value={selectedSkillOptions}
//                     onChange={handleChangeSkills}
//                     closeMenuOnSelect={false}
//                     // keep menu stable to avoid stealing focus
//                     backspaceRemovesValue
//                     captureMenuScroll
//                     styles={{
//                       control: (base) => ({
//                         ...base,
//                         background: "#F9FBFF",
//                         borderColor: "#F0F2F7",
//                         borderRadius: 12,
//                         padding: 2,
//                       }),
//                       multiValue: (base) => ({
//                         ...base,
//                         backgroundColor: "#EE5F2B",
//                       }),
//                       multiValueLabel: (base) => ({ ...base, color: "#fff" }),
//                       multiValueRemove: (base) => ({
//                         ...base,
//                         color: "#fff",
//                         ":hover": { background: "#2A3A54", color: "#fff" },
//                       }),
//                     }}
//                   />
//                   {errors.skill_id && (
//                     <p className="text-red-500 text-sm mt-2">*Select Skill!</p>
//                   )}
//                 </Card>
//               </div>

//               {/* Education */}
//               <Card title="Education" className="mt-6">
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                   <div>
//                     <label className="text-sm font-semibold">Degree</label>
//                     <Input
//                       placeholder="Enter your degree"
//                       name="degree"
//                       value={formData.degree || ""}
//                       onChange={handleChange}
//                       className="mt-2"
//                     />
//                     {errors.degree && (
//                       <p className="text-red-500 text-sm mt-1">
//                         *Select Your Degree!
//                       </p>
//                     )}
//                   </div>

//                   <div>
//                     <label className="text-sm font-semibold">School</label>
//                     <Input
//                       placeholder="Enter your school"
//                       name="school"
//                       value={formData.school || ""}
//                       onChange={handleChange}
//                       className="mt-2"
//                     />
//                   </div>

//                   <div className="md:col-span-1">
//                     <label className="text-sm font-semibold">Graduation Year</label>
//                     <Input
//                       placeholder="e.g. 2023"
//                       name="graduation_year"
//                       value={formData.graduation_year || ""}
//                       onChange={handleChange}
//                       className="mt-2"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                     />
//                   </div>
//                 </div>
//               </Card>

//               {/* Work History */}
//               <Card title="Work History" className="mt-6">
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                   <div>
//                     <label className="text-sm font-semibold">Title</label>
//                     <Input
//                       placeholder="Enter your position"
//                       name="title"
//                       value={formData.title || ""}
//                       onChange={handleChange}
//                       className="mt-2"
//                     />
//                   </div>
//                   <div>
//                     <label className="text-sm font-semibold">Company</label>
//                     <Input
//                       placeholder="Company name"
//                       name="company"
//                       value={formData.company || ""}
//                       onChange={handleChange}
//                       className="mt-2"
//                     />
//                   </div>
//                 </div>

//                 <div className="flex items-center gap-3 mt-5">
//                   <input
//                     id="current"
//                     type="checkbox"
//                     className="w-5 h-5 accent-[#EE5F2B]"
//                     checked={currentlyWorking}
//                     onChange={(e) =>
//                       handleChange({
//                         target: {
//                           name: "currently_working",
//                           value: e.target.checked ? "yes" : "no",
//                         },
//                       })
//                     }
//                   />
//                   <label htmlFor="current" className="text-sm font-semibold">
//                     I currently work here
//                   </label>
//                 </div>

//                 {/* Dates */}
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
//                   {/* Start Date */}
//                   <div>
//                     <p className="text-sm font-semibold mb-2">Start Date</p>
//                     <div className="grid grid-cols-2 gap-3">
//                       <select
//                         name="start_month"
//                         value={formData.start_month || ""}
//                         onChange={handleChange}
//                         className="bg-[#F9FBFF] border border-[#F0F2F7] rounded-lg px-3 py-2"
//                       >
//                         <option value="">Month</option>
//                         {monthNames.map((m) => (
//                           <option key={m} value={m}>
//                             {m}
//                           </option>
//                         ))}
//                       </select>
//                       <Input
//                         placeholder="Year"
//                         name="start_year"
//                         value={formData.start_year || ""}
//                         onChange={handleChange}
//                         inputMode="numeric"
//                         pattern="[0-9]*"
//                       />
//                     </div>
//                   </div>

//                   {/* End Date */}
//                   <div>
//                     <p className="text-sm font-semibold mb-2">End Date</p>
//                     <div className="grid grid-cols-2 gap-3">
//                       <select
//                         name="end_month"
//                         value={formData.end_month || ""}
//                         onChange={handleChange}
//                         disabled={disableEndDate}
//                         className={`bg-[#F9FBFF] border border-[#F0F2F7] rounded-lg px-3 py-2 ${
//                           disableEndDate ? "opacity-60 cursor-not-allowed" : ""
//                         }`}
//                       >
//                         <option value="">Month</option>
//                         {monthNames.map((m) => (
//                           <option key={m} value={m}>
//                             {m}
//                           </option>
//                         ))}
//                       </select>
//                       <Input
//                         placeholder="Year"
//                         name="end_year"
//                         value={formData.end_year || ""}
//                         onChange={handleChange}
//                         disabled={disableEndDate}
//                         className={disableEndDate ? "opacity-60" : ""}
//                         inputMode="numeric"
//                         pattern="[0-9]*"
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {/* Description */}
//                 <div className="mt-5">
//                   <label className="text-sm font-semibold">Description</label>
//                   <Textarea
//                     rows={6}
//                     placeholder="Job description"
//                     name="description"
//                     value={formData.description || ""}
//                     onChange={handleChange}
//                     className="mt-2"
//                   />
//                 </div>
//               </Card>

//               {errors.general && (
//                 <p className="text-red-500 text-sm mt-4">{errors.general}</p>
//               )}
//             </>
//           )}
//         </div>
//       </div>

//       {/* (Optional) Modal */}
//       {showModal && (
//         <>
//           <div className="fixed inset-0 bg-black/40 z-40"></div>
//           <div className="fixed inset-0 z-50 flex justify-center items-center px-4">
//             <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-2xl relative">
//               <button
//                 onClick={() => setShowModal(false)}
//                 className="absolute top-3 right-4 text-2xl text-gray-500 hover:text-black"
//               >
//                 ×
//               </button>
//               <h2 className="text-2xl font-bold text-center mb-4">Add Degree</h2>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <label className="text-sm font-semibold">Title</label>
//                   <Input placeholder="Enter your position" />
//                 </div>
//                 <div>
//                   <label className="text-sm font-semibold">Company</label>
//                   <Input placeholder="Company name" />
//                 </div>
//                 <div>
//                   <label className="text-sm font-semibold">Start Month</label>
//                   <select className="bg-[#F9FBFF] border border-[#F0F2F7] rounded-lg px-3 py-2 w-full">
//                     <option>Month</option>
//                     {monthNames.map((m) => (
//                       <option key={m}>{m}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div>
//                   <label className="text-sm font-semibold">Start Year</label>
//                   <Input placeholder="Year" inputMode="numeric" pattern="[0-9]*" />
//                 </div>
//                 <div>
//                   <label className="text-sm font-semibold">End Month</label>
//                   <select className="bg-[#F9FBFF] border border-[#F0F2F7] rounded-lg px-3 py-2 w-full">
//                     <option>Month</option>
//                     {monthNames.map((m) => (
//                       <option key={m}>{m}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div>
//                   <label className="text-sm font-semibold">End Year</label>
//                   <Input placeholder="Year" inputMode="numeric" pattern="[0-9]*" />
//                 </div>
//                 <div className="md:col-span-2">
//                   <label className="text-sm font-semibold">Description</label>
//                   <Textarea rows={4} className="mt-2" />
//                 </div>
//               </div>

//               <div className="flex justify-center mt-6">
//                 <GradientButton onClick={() => setShowModal(false)}>
//                   Save
//                 </GradientButton>
//               </div>
//             </div>
//           </div>
//         </>
//       )}
//     </>
//   );
// };

// export default OtherDetails;
import React, { useEffect, useState, useMemo, memo, useCallback } from "react";
import "react-phone-input-2/lib/style.css";
import { NavLink } from "react-router-dom";
import apiKey from "../../../config/apiKey";
import axios from "axios";
import { toast } from "react-toastify";
import CreatableSelect from "react-select/creatable"; // 🔹 changed
import { useTranslation } from "react-i18next";

const GradientButton = memo(({ children, className = "", ...props }) => (
  <button
    {...props}
    className={`bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] hover:from-[#2A3A54] hover:to-[#EE5F2B] text-white font-semibold text-sm px-5 py-2 rounded-lg shadow-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
  >
    {children}
  </button>
));

const Input = memo(({ className = "", ...p }) => (
  <input
    {...p}
    className={`outline-none px-3 py-2 w-full bg-[#F9FBFF] border border-[#F0F2F7] rounded-lg focus:ring-2 focus:ring-[#EE5F2B]/30 ${className}`}
  />
));

const Textarea = memo(({ className = "", ...p }) => (
  <textarea
    {...p}
    className={`outline-none px-3 py-2 w-full bg-[#F9FBFF] border border-[#F0F2F7] rounded-lg focus:ring-2 focus:ring-[#EE5F2B]/30 ${className}`}
  />
));

const Card = memo(({ title, children, className = "" }) => (
  <div className={`rounded-2xl border border-[#E9EDF3] bg-white shadow-sm p-5 ${className}`}>
    {title && <h3 className="text-lg font-semibold text-gray-800 mb-3">{title}</h3>}
    {children}
  </div>
));

const OtherDetails = () => {
  const { t } = useTranslation();
  const teacher = JSON.parse(localStorage.getItem("edo-teacher"));
  const authHeaders = useMemo(
    () => ({ headers: { Authorization: `Bearer ${teacher?.token}` } }),
    [teacher?.token]
  );

  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [skills, setSkills] = useState([]);

  const [formData, setFormData] = useState({
    skill_id: [],
    currently_working: "no",
    bio: "",
    degree: "",
    school: "",
    graduation_year: "",
    title: "",
    company: "",
    start_month: "",
    start_year: "",
    end_month: "",
    end_year: "",
    description: "",
  });

  const monthNames = useMemo(
    () => [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    []
  );

  // ---------- handlers ----------
  const handleChange = useCallback((e) => {
    const { name, value } = e.target;

    if (name === "currently_working") {
      const working = value;
      setFormData((prev) => ({
        ...prev,
        [name]: working,
        ...(working === "yes" ? { end_month: "", end_year: "" } : {}),
      }));
      setErrors((prev) => ({ ...prev, [name]: "" }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  }, []);

  const handleChangeSkills = useCallback((selectedOptions) => {
    const selectedValues = (selectedOptions || []).map((o) => o.value);
    setFormData((prev) => ({ ...prev, skill_id: selectedValues }));
    setErrors((prev) => ({ ...prev, skill_id: "" }));
  }, []);

  // 🔹 New: create skill from select
  const handleCreateSkill = useCallback(
    async (inputValue) => {
      const name = inputValue.trim();
      if (!name) return;

      try {
        // Tum yeh endpoint banaoge: POST /api/edolutions/teacher/skills
        // Expect response: { id, skill_name, ... }
        const res = await axios.post(
          `${apiKey}/api/edolutions/teacher/skills`,
          { skill_name: name },
          authHeaders
        );

        const newSkill = res.data;

        // Skills list update
        setSkills((prev) => [...prev, newSkill]);

        // Form me selected skills me add karo
        setFormData((prev) => ({
          ...prev,
          skill_id: [...prev.skill_id, newSkill.id],
        }));

        setErrors((prev) => ({ ...prev, skill_id: "" }));
      } catch (e) {
        console.error("Error creating skill:", e);
        toast.error(t("teacherDash.otherDetails.unableAddSkill"), {
          position: "bottom-right",
          autoClose: 4000,
          theme: "colored",
          style: { background: "#2A3A54", color: "#fff" },
        });
      }
    },
    [authHeaders]
  );

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setIsLoading(true);

      try {
        const { data } = await axios.post(
          `${apiKey}/api/edolutions/teacher/add-users-details`,
          formData,
          authHeaders
        );

        toast.success(data?.message || "Saved", {
          position: "bottom-right",
          autoClose: 4000,
          theme: "colored",
          style: { background: "#2A3A54", color: "#fff" },
        });
      } catch (err) {
        if (err.response?.data?.data) {
          setErrors(err.response.data.data);
        } else {
          setErrors({ general: t("teacherDash.otherDetails.unexpectedError") });
        }
      } finally {
        setIsLoading(false);
      }
    },
    [formData, authHeaders]
  );

  // ---------- effects ----------
  useEffect(() => {
    let cancel = false;
    (async () => {
      setLoading(true);
      try {
        const [skillsRes, detailsRes] = await Promise.all([
          axios.get(`${apiKey}/api/edolutions/teacher/skills`, authHeaders),
          axios.get(`${apiKey}/api/edolutions/teacher/users-details`, authHeaders),
        ]);

        if (cancel) return;

        setSkills(skillsRes.data || []);
if (detailsRes.data?.[0]) {
  const d = detailsRes.data[0];

  // 🔹 skill_id parsing (string "[52,54,53]" → array [52, 54, 53])
  let parsedSkillIds = [];
  if (Array.isArray(d.skill_id)) {
    parsedSkillIds = d.skill_id;
  } else if (typeof d.skill_id === "string" && d.skill_id.trim() !== "") {
    try {
      parsedSkillIds = JSON.parse(d.skill_id);
    } catch (e) {
      console.warn("Failed to parse skill_id JSON:", d.skill_id);
      parsedSkillIds = [];
    }
  }

  setFormData((prev) => ({
    ...prev,
    ...d,
    skill_id: parsedSkillIds, // 👈 yahan ab proper array aa jayega
    currently_working:
      d.currently_working === "yes" || d.currently_working === "no"
        ? d.currently_working
        : "no",
    bio: d.bio || "",
    degree: d.degree || "",
    school: d.school || "",
    graduation_year: d.graduation_year || "",
    title: d.title || "",
    company: d.company || "",
    start_month: d.start_month || "",
    start_year: d.start_year || "",
    end_month: d.end_month || "",
    end_year: d.end_year || "",
    description: d.description || "",
  }));
}

      } catch (e) {
        console.error(e);
      } finally {
        if (!cancel) setLoading(false);
      }
    })();

    return () => {
      cancel = true;
    };
  }, [authHeaders]);

  // ---------- derived ----------
  const skillOptions = useMemo(
    () => (skills || []).map((s) => ({ value: s.id, label: s.skill_name })),
    [skills]
  );

  const selectedSkillOptions = useMemo(
    () => skillOptions.filter((o) => formData.skill_id.includes(o.value)),
    [skillOptions, formData.skill_id]
  );

  const currentlyWorking = formData.currently_working === "yes";
  const disableEndDate = currentlyWorking;

  // ---------- render ----------
  return (
    <>
      <div className="flex items-center xl:p-5 sm:p-0 justify-center">
        <div className="w-full border rounded-3xl shadow-xl p-5 px-6 md:px-10 bg-white">
          {/* Header */}
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold text-gray-800">{t("teacherDash.common.settings")}</h1>
            <GradientButton onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? t("teacherDash.common.saving") : t("teacherDash.common.save")}
            </GradientButton>
          </div>

          {/* Tabs */}
          <div className="flex flex-wrap gap-6 border-b pb-3 text-sm font-semibold text-gray-700 mt-5">
            <NavLink
              to=".././profile-setting-tech"
              className={({ isActive }) =>
                isActive
                  ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
                  : "hover:text-[#2A3A54]"
              }
            >
              {t("teacherDash.settingTabs.profileSettings")}
            </NavLink>

            <NavLink
              to=".././specialization-tech"
              className={({ isActive }) =>
                isActive
                  ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
                  : "hover:text-[#2A3A54]"
              }
            >
              {t("teacherDash.settingTabs.specializationsWp")}
            </NavLink>

            <span className="text-[#EE5F2B] border-b-2 border-[#EE5F2B]">
              {t("teacherDash.settingTabs.otherDetails")}
            </span>

            <NavLink
              to=".././security"
              className={({ isActive }) =>
                isActive
                  ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
                  : "hover:text-[#2A3A54]"
              }
            >
              {t("teacherDash.settingTabs.privacySecurity")}
            </NavLink>
          </div>

          {/* Loading / Content */}
          {loading ? (
            <div className="w-full py-10 grid place-items-center">
              <div className="w-12 h-12 border-4 rounded-full border-[#F0F0F0] border-t-[#EE5F2B] animate-spin"></div>
              <p className="mt-4 font-semibold text-[#EE5F2B]">{t("teacherDash.homeTution.loadingText")}</p>
            </div>
          ) : (
            <>
              {/* Personal + Skills */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
                <Card title={t("teacherDash.otherDetails.personalCardTitle")}>
                  <label className="text-sm font-semibold">{t("teacherDash.otherDetails.yourBioLabel")}</label>
                  <Textarea
                    rows={5}
                    placeholder={t("teacherDash.otherDetails.bioPlaceholder")}
                    name="bio"
                    value={formData.bio || ""}
                    onChange={handleChange}
                    className="mt-2"
                  />
                  {errors.bio && (
                    <p className="text-red-500 text-sm mt-1">{t("teacherDash.otherDetails.insertBioError")}</p>
                  )}
                </Card>

                <Card title={t("teacherDash.otherDetails.selectSkillsCardTitle")}>
                  <CreatableSelect
                    className="mt-1"
                    options={skillOptions}
                    isMulti
                    value={selectedSkillOptions}
                    onChange={handleChangeSkills}
                    onCreateOption={handleCreateSkill} // 🔹 allow creating new
                    closeMenuOnSelect={false}
                    backspaceRemovesValue
                    captureMenuScroll
                    placeholder={t("teacherDash.otherDetails.skillsPlaceholder")}
                    styles={{
                      control: (base) => ({
                        ...base,
                        background: "#F9FBFF",
                        borderColor: "#F0F2F7",
                        borderRadius: 12,
                        padding: 2,
                      }),
                      multiValue: (base) => ({
                        ...base,
                        backgroundColor: "#EE5F2B",
                      }),
                      multiValueLabel: (base) => ({ ...base, color: "#fff" }),
                      multiValueRemove: (base) => ({
                        ...base,
                        color: "#fff",
                        ":hover": { background: "#2A3A54", color: "#fff" },
                      }),
                    }}
                  />
                  {errors.skill_id && (
                    <p className="text-red-500 text-sm mt-2">{t("teacherDash.otherDetails.selectSkillError")}</p>
                  )}
                </Card>
              </div>

              {/* Education */}
              <Card title={t("teacherDash.otherDetails.educationCardTitle")} className="mt-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div>
                    <label className="text-sm font-semibold">{t("teacherDash.otherDetails.degreeLabel")}</label>
                    <Input
                      placeholder={t("teacherDash.otherDetails.degreePlaceholder")}
                      name="degree"
                      value={formData.degree || ""}
                      onChange={handleChange}
                      className="mt-2"
                    />
                    {errors.degree && (
                      <p className="text-red-500 text-sm mt-1">
                        {t("teacherDash.otherDetails.degreeError")}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="text-sm font-semibold">{t("teacherDash.otherDetails.schoolLabel")}</label>
                    <Input
                      placeholder={t("teacherDash.otherDetails.schoolPlaceholder")}
                      name="school"
                      value={formData.school || ""}
                      onChange={handleChange}
                      className="mt-2"
                    />
                  </div>

                  <div className="md:col-span-1">
                    <label className="text-sm font-semibold">{t("teacherDash.otherDetails.graduationYearLabel")}</label>
                    <Input
                      placeholder={t("teacherDash.otherDetails.graduationYearPlaceholder")}
                      name="graduation_year"
                      value={formData.graduation_year || ""}
                      onChange={handleChange}
                      className="mt-2"
                      inputMode="numeric"
                      pattern="[0-9]*"
                    />
                  </div>
                </div>
              </Card>

              {/* Work History */}
              <Card title={t("teacherDash.otherDetails.workHistoryCardTitle")} className="mt-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div>
                    <label className="text-sm font-semibold">{t("teacherDash.otherDetails.titleLabel")}</label>
                    <Input
                      placeholder={t("teacherDash.otherDetails.positionPlaceholder")}
                      name="title"
                      value={formData.title || ""}
                      onChange={handleChange}
                      className="mt-2"
                    />
                  </div>
                  <div>
                    <label className="text-sm font-semibold">{t("teacherDash.otherDetails.companyLabel")}</label>
                    <Input
                      placeholder={t("teacherDash.otherDetails.companyPlaceholder")}
                      name="company"
                      value={formData.company || ""}
                      onChange={handleChange}
                      className="mt-2"
                    />
                  </div>
                </div>

                <div className="flex items-center gap-3 mt-5">
                  <input
                    id="current"
                    type="checkbox"
                    className="w-5 h-5 accent-[#EE5F2B]"
                    checked={currentlyWorking}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: "currently_working",
                          value: e.target.checked ? "yes" : "no",
                        },
                      })
                    }
                  />
                  <label htmlFor="current" className="text-sm font-semibold">
                    {t("teacherDash.otherDetails.currentlyWorkingLabel")}
                  </label>
                </div>

                {/* Dates */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
                  {/* Start Date */}
                  <div>
                    <p className="text-sm font-semibold mb-2">{t("teacherDash.otherDetails.startDateLabel")}</p>
                    <div className="grid grid-cols-2 gap-3">
                      <select
                        name="start_month"
                        value={formData.start_month || ""}
                        onChange={handleChange}
                        className="bg-[#F9FBFF] border border-[#F0F2F7] rounded-lg px-3 py-2"
                      >
                        <option value="">{t("teacherDash.otherDetails.monthOption")}</option>
                        {monthNames.map((m) => (
                          <option key={m} value={m}>
                            {m}
                          </option>
                        ))}
                      </select>
                      <Input
                        placeholder={t("teacherDash.otherDetails.yearPlaceholder")}
                        name="start_year"
                        value={formData.start_year || ""}
                        onChange={handleChange}
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />
                    </div>
                  </div>

                  {/* End Date */}
                  <div>
                    <p className="text-sm font-semibold mb-2">{t("teacherDash.otherDetails.endDateLabel")}</p>
                    <div className="grid grid-cols-2 gap-3">
                      <select
                        name="end_month"
                        value={formData.end_month || ""}
                        onChange={handleChange}
                        disabled={disableEndDate}
                        className={`bg-[#F9FBFF] border border-[#F0F2F7] rounded-lg px-3 py-2 ${
                          disableEndDate ? "opacity-60 cursor-not-allowed" : ""
                        }`}
                      >
                        <option value="">{t("teacherDash.otherDetails.monthOption")}</option>
                        {monthNames.map((m) => (
                          <option key={m} value={m}>
                            {m}
                          </option>
                        ))}
                      </select>
                      <Input
                        placeholder={t("teacherDash.otherDetails.yearPlaceholder")}
                        name="end_year"
                        value={formData.end_year || ""}
                        onChange={handleChange}
                        disabled={disableEndDate}
                        className={disableEndDate ? "opacity-60" : ""}
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />
                    </div>
                  </div>
                </div>

                {/* Description */}
                <div className="mt-5">
                  <label className="text-sm font-semibold">{t("teacherDash.otherDetails.descriptionLabel")}</label>
                  <Textarea
                    rows={6}
                    placeholder={t("teacherDash.otherDetails.jobDescriptionPlaceholder")}
                    name="description"
                    value={formData.description || ""}
                    onChange={handleChange}
                    className="mt-2"
                  />
                </div>
              </Card>

              {errors.general && (
                <p className="text-red-500 text-sm mt-4">{errors.general}</p>
              )}
            </>
          )}
        </div>
      </div>

      {/* (Optional) Modal – untouched */}
      {showModal && (
        <>
          <div className="fixed inset-0 bg-black/40 z-40"></div>
          <div className="fixed inset-0 z-50 flex justify-center items-center px-4">
            <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-2xl relative">
              <button
                onClick={() => setShowModal(false)}
                className="absolute top-3 right-4 text-2xl text-gray-500 hover:text-black"
              >
                ×
              </button>
              <h2 className="text-2xl font-bold text-center mb-4">{t("teacherDash.otherDetails.addDegreeTitle")}</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="text-sm font-semibold">{t("teacherDash.otherDetails.titleLabel")}</label>
                  <Input placeholder={t("teacherDash.otherDetails.positionPlaceholder")} />
                </div>
                <div>
                  <label className="text-sm font-semibold">{t("teacherDash.otherDetails.companyLabel")}</label>
                  <Input placeholder={t("teacherDash.otherDetails.companyPlaceholder")} />
                </div>
                <div>
                  <label className="text-sm font-semibold">{t("teacherDash.otherDetails.startMonthLabel")}</label>
                  <select className="bg-[#F9FBFF] border border-[#F0F2F7] rounded-lg px-3 py-2 w-full">
                    <option>{t("teacherDash.otherDetails.monthOption")}</option>
                    {monthNames.map((m) => (
                      <option key={m}>{m}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="text-sm font-semibold">{t("teacherDash.otherDetails.startYearLabel")}</label>
                  <Input placeholder={t("teacherDash.otherDetails.yearPlaceholder")} inputMode="numeric" pattern="[0-9]*" />
                </div>
                <div>
                  <label className="text-sm font-semibold">{t("teacherDash.otherDetails.endMonthLabel")}</label>
                  <select className="bg-[#F9FBFF] border border-[#F0F2F7] rounded-lg px-3 py-2 w-full">
                    <option>{t("teacherDash.otherDetails.monthOption")}</option>
                    {monthNames.map((m) => (
                      <option key={m}>{m}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="text-sm font-semibold">{t("teacherDash.otherDetails.endYearLabel")}</label>
                  <Input placeholder={t("teacherDash.otherDetails.yearPlaceholder")} inputMode="numeric" pattern="[0-9]*" />
                </div>
                <div className="md:col-span-2">
                  <label className="text-sm font-semibold">{t("teacherDash.otherDetails.descriptionLabel")}</label>
                  <Textarea rows={4} className="mt-2" />
                </div>
              </div>

              <div className="flex justify-center mt-6">
                <GradientButton onClick={() => setShowModal(false)}>
                  {t("teacherDash.common.save")}
                </GradientButton>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default OtherDetails;
